import React from "react";
import { useLocation } from "react-router";
import NewHelpCenter from "./NewHelpCenter";
import QnHelpCenter from "./QnHelpCenter";

const HelpCenter: React.FC = React.memo(function () {
    const location = useLocation();

    if (import.meta.env.VITE_IS_QN) {
        return <QnHelpCenter />;
    }

    if (location.pathname === "/cs") {
        return (
            <div style={{ width: "100%", height: "100vh", background: "#eef1f4", paddingTop: 30 }}>
                <NewHelpCenter />
            </div>
        );
    }

    return <NewHelpCenter />;
});

export default HelpCenter;
